import reduxFetch from 'react-redux-fetch';
import { createErrorMessage } from 'nallian-shared-ui/lib/lib/createErrorMessage';
import apiRoutes from '../../../app/api/routes';

export const CREATE_FEATURE_SUBSCRIPTION_RESOURCE = 'createFeatureSubscription';

const createFeatureSubscriptionService = ComposedComponent =>
  reduxFetch([
    {
      resource: CREATE_FEATURE_SUBSCRIPTION_RESOURCE,
      method: 'post',
      request: (appId, installationId, featureId, body, callback, rejectCallback, resource, t) => ({
        url: apiRoutes.featureSubscriptions(appId, installationId, featureId),
        body,
        meta: {
          mergeWithOtherList: {
            resource,
            idProp: 'subscriptionId',
          },
          callback,
          rejectCallback,
          toaster: {
            onErrorMessage: createErrorMessage(t, 'createFeatureSubscriptionFailed'),
            onSuccessMessage: t('createFeatureSubscriptionSuccess'),
          },
        },
      }),
    },
  ])(ComposedComponent);

export default createFeatureSubscriptionService;
